import { SocialPlatform } from '@/lib/api';

export const PLATFORM_CHARACTER_LIMITS: Record<SocialPlatform, number> = {
  twitter: 280,
  linkedin: 3000,
  facebook: 63206,
  instagram: 2200,
};

export const ALL_PLATFORMS: SocialPlatform[] = ['twitter', 'linkedin', 'facebook', 'instagram'];
